import { Component, OnInit,Input } from '@angular/core';
import { iconpack } from 'src/icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ShareService } from '@ngx-share/core';
@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.sass']
})
export class ShareComponent implements OnInit {

  
  @Input('sharebtn') sharebtn: object;
  constructor(library: FaIconLibrary, public share: ShareService, ) { 
    library.addIcons(...iconpack);
  }

  ngOnInit(): void {

  }

}
